module.exports = __webpack_public_path__ + "img/national emblem.6cfc4e7c.png";